/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendResetPasswordLinkDto } from '../../models/send-reset-password-link-dto';
import { ServerProblem } from '../../models/server-problem';

export interface SignUpControllerSendResetPasswordLink$Params {
      body: SendResetPasswordLinkDto
}

export function signUpControllerSendResetPasswordLink(http: HttpClient, rootUrl: string, params: SignUpControllerSendResetPasswordLink$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ServerProblem>>> {
  const rb = new RequestBuilder(rootUrl, signUpControllerSendResetPasswordLink.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ServerProblem>>;
    })
  );
}

signUpControllerSendResetPasswordLink.PATH = '/account/send-reset-password-link';
